/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'backgrounds/poster-text-icon': {
    width: 16,
    height: 16,
    viewBox: '0 0 70 61.3',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" d="M12 32l18.68 8.84L0 57.31z" _fill="#fff"/><path pid="1" d="M67.05 43.75A30.64 30.64 0 1152.45 3a30.65 30.65 0 0114.6 40.75z" _fill="#fff"/><circle pid="2" cx="39.03" cy="30.77" r="27.8" _fill="#e25046"/></g></g>'
  }
})
